import { isFlowTheme } from 'src/Libs/utils'
import e3dcLogo from 'src/Resources/Images/logos/e3dc-logo.svg'
import flowMaintenancePageLogo from 'src/Resources/Images/logos/flow-maintenance-page-logo.svg'

/** Hardcoded translations because of the given design and to keep aligned with the maintenance page outside of the react app */
export const TITLE_GERMAN = 'Die Sonne geht bald wieder auf.'
export const SUBTITLE_GERMAN_1 = isFlowTheme ? 'Wir arbeiten am Portal für Sie.' : 'Wir arbeiten am E3/DC-Kundenportal für Sie.'
export const SUBTITLE_GERMAN_2 = 'Bitte kommen Sie später wieder.'
export const FOOTER_ENGLISH_1 = isFlowTheme ? 'We are working on the Portal for you. ' : 'We are working on the E3/DC Portal for you. '
export const FOOTER_ENGLISH_2 = 'Please come back later.'
export const BUTTON_TEXT_GERMAN = 'neu laden'
export const MAINTENANCE_LOGO = isFlowTheme ? flowMaintenancePageLogo : e3dcLogo

export const LOGO_IMAGE_WIDTH = 132
